export default process.env.API_ROOT  + '/bylBaseCenter'



// WEBPACK FOOTER //
// ./src/services/bylBaseCenter/rootapi.js